import skyEffects from './landscapeSkyEffects.json';
import {
  createMixer,
  createNumericAnimation,
} from '../../common/createMixer';

export default function createSkyAnimation() {
  const skyParmTimes = [5, 8, 8.5, 10.5];
  const skyParmTracks = [
    // sky_parm_turbidity
    createNumericAnimation('sky_turb', skyParmTimes, [11.2, 11.2, 11.2, 11.2], 20, '.turbidity'),
    // sky_parm_rayleigh
    createNumericAnimation('sky_rayleigh', skyParmTimes, [.313, .313, .313, .313], 20, '.rayleigh'),
    // sky_parm_mieCof
    createNumericAnimation('sky_meiCof', skyParmTimes, [.003, .003, .003, .003], 20, '.mieCoefficient'),
    // sky_parm_mieDir
    createNumericAnimation('sky_meiDir', skyParmTimes, [.693, .693, .693, .398], 20, '.mieDirectionalG'),
    // sky_parm_elev
    createNumericAnimation('sky_elev', skyParmTimes, [-1.4, -1.4, -1.4, -1.7], 20, '.elevation'),
    // sky_parm_azimuth
    createNumericAnimation('sky_azimuth', skyParmTimes, [-180, -180, -180, -180], 20, '.azimuth'),
  ];

  return createMixer(skyEffects, skyParmTracks);
};